module.exports = __webpack_public_path__ + "img/buddy_mouth-03.3519d996.svg";